import getChartColorsArray from "../../Components/Commons/ChartsDynamicColor";

/*
ENTERED = 0
DISABLED = -1
UPDATED = 1
WARNING = 2
OUTDATED = 3
*/

//Constants
const WebServiceStatusColor = ({ status}) => {
	if (status === 0) {
		return getChartColorsArray('["--vz-primary"]')[0];
	} else if (status === -1) {
		return getChartColorsArray('["--vz-dark"]')[0];
	} else if (status === 1) {
		return getChartColorsArray('["--vz-success"]')[0];
	} else if (status === 2) {
		return getChartColorsArray('["--vz-danger"]')[0];
	} else if (status === 3) {
		return getChartColorsArray('["--vz-warning"]')[0];
	}
};

export default WebServiceStatusColor;